import { section } from '@/glow';
import { AnimateRichText } from '@/lib/animation';

section('rich-text', {
  onLoad() {
    this.AnimateRichText = AnimateRichText(this.container);
  },

  onUnload() {
    this.AnimateRichText?.disconnect();
  }
});
